import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

/**
 * En enkelt brukers månedskapasitet. Lett spørring (kun ett felt) brukt til å
 * kohort-gate månedslukking: kun ansatte med fakturerbar tid
 * (`monthly_capacity_hours > 0`) skal attestere/nudges (VIB-1246 Fase 3).
 */
export function useUserCapacity(userId: string | null) {
  return useQuery({
    queryKey: ["user-capacity", userId],
    enabled: !!userId,
    staleTime: 10 * 60 * 1000,
    queryFn: async (): Promise<number> => {
      if (!userId) return 0;
      const { data, error } = await supabase
        .from("users")
        .select("monthly_capacity_hours")
        .eq("id", userId)
        .single();
      if (error) throw error;
      return Number(data?.monthly_capacity_hours ?? 0);
    },
  });
}
